import React, { useEffect, useState } from "react";
import "./UserDetailModel.css";
import { getRecords } from "../../../../services/api.service";

const UserDetailsModal = ({ onClose, id, type }) => {
  const [user, setUser] = useState(null);
  const [warehouse, setWarehouse] = useState(null);

  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        const storedUserDetails = localStorage.getItem("userDetails");
        if (storedUserDetails) {
          const parsedUser = JSON.parse(storedUserDetails);
          setUser(parsedUser);
          getRoles(parsedUser?.role_id);
        }
      } else if (type == "user") {
        const payload = {
          modelName: "user_masters",
          whereCondition: {
            id: id,
          },
        };
        const responseData = await getRecords(payload, "/getRecords");
        if (responseData.data && responseData.data.length > 0) {
          setUser(responseData.data[0]);
          getRoles(responseData.data[0]?.role_id);
        }
      } else if (type == "warehouse") {
        const payload = {
          modelName: "warehouse_masters",
          whereCondition: {
            id: id,
          },
        };
        const responseData = await getRecords(payload, "/getRecords");
        if (responseData.data && responseData.data.length > 0) {
          setWarehouse(responseData.data[0]);
          getCity(responseData.data[0].city_id);
          getState(responseData.data[0].state_id);
        }
      } else if (type == "customer") {
        const payload = {
          modelName: "company_masters",
          whereCondition: {
            id: id,
          },
          relations: [
            {
              module: "company_documents",
              moduleAs: "documents",
            },
          ],
        };
        const responseData = await getRecords(payload, "/getRecords");
        if (responseData.data && responseData.data.length > 0) {
          setCustomer(responseData.data[0]);
        }
      }
    };

    fetchData();

    // return () => {
    //   setUser(null);
    // };
  }, [id, type]);

  const getRoles = async (roleId) => {
    // Fetch roles from API or database
    const payload = {
      modelName: "role_masters",
      whereCondition: {
        id: roleId,
      },
    };
    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.data && responseData.data.length > 0) {
      const roleName = responseData.data[0].role_name;
      setUser((prevUser) => ({ ...prevUser, role_name: roleName }));
    }
  };
  const getCity = async (id) => {
    // Fetch roles from API or database
    const payload = {
      modelName: "city_masters",
      whereCondition: {
        id: id,
      },
    };
    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.data && responseData.data.length > 0) {
      const cityName = responseData.data[0].city_name;
      setWarehouse((prevUser) => ({ ...prevUser, city_name: cityName }));
    }
  };
  const getState = async (id) => {
    // Fetch roles from API or database
    const payload = {
      modelName: "state_masters",
      whereCondition: {
        id: id,
      },
    };
    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.data && responseData.data.length > 0) {
      const stateName = responseData.data[0].state_name;
      setWarehouse((prevUser) => ({ ...prevUser, state_name: stateName }));
    }
  };

  return (
    <>
      {type == "warehouse" ? (
        <div
          className="modal-backdrop"
          style={{
            background: "rgba(21, 2, 2, 0.5)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          }}>
          <div
            className="modal-container"
            style={{ padding: "15px", overflow: "visible" }}>
            <header className="modal-header">
              <h2>Warehouse Details</h2>
              <button className="icon-button" onClick={onClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </header>

            <div className="modal-content">
              <div className="user-avatar">
                <div className="avatar-circle">
                  {warehouse?.warehouse_name
                    ?.split(" ")
                    .map((word) => word[0])
                    .join("") || "N/A"}
                </div>
                <h3>{warehouse?.warehouse_name || "Not Provided"} </h3>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <span className="info-label">Warehouse Type</span>
                  <span className="info-value">
                    {warehouse?.type == 1
                      ? "Bermad"
                      : warehouse?.type == 2
                      ? "Contractor"
                      : "Not Provided" || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">State</span>
                  <span className="info-value">
                    {warehouse?.state_name || "Not Provided"}
                  </span>
                </div>

                <div className="info-card">
                  <span className="info-label">City</span>
                  <span className="info-value">
                    {warehouse?.city_name || "Not Provided"}
                  </span>
                </div>

                <div className="info-card">
                  <span className="info-label">Address</span>
                  <span className="info-value">
                    {warehouse?.address || "Not Provided"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : type == "user" ? (
        <div
          className="modal-backdrop"
          style={{
            background: "rgba(21, 2, 2, 0.5)", // Semi-transparent red background
            backdropFilter: "blur(10px)", // Apply the blur effect
            WebkitBackdropFilter: "blur(10px)", // For Safari support
          }}>
          <div className="modal-container" style={{ padding: "15px" }}>
            <header className="modal-header">
              <h2>Profile Details</h2>
              <button className="icon-button" onClick={onClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </header>

            <div className="modal-content">
              <div className="user-avatar">
                <div className="avatar-circle">
                  {user?.first_name?.[0]}
                  {user?.last_name?.[0]}
                </div>
                <h3>
                  {user?.first_name || "Not Provided"}{" "}
                  {user?.last_name || "Not Provided"}
                </h3>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <span className="info-label">Email</span>
                  <span className="info-value">
                    {user?.email_id || "Not Provided"}
                  </span>
                </div>

                <div className="info-card">
                  <span className="info-label">Mobile Number</span>
                  <span className="info-value">
                    {user?.mobile_number || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">User Type</span>
                  <span className="info-value">
                    {user?.user_type == 1
                      ? "User"
                      : user?.user_type == 2
                      ? "Subcontractor"
                      : user?.user_type == 3
                      ? "Customer"
                      : user?.user_type == 4
                      ? "Subcontractor Sub User"
                      : "Not Provided" || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">Role</span>
                  <span className="info-value">
                    {user?.role_name || "Not Provided"}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <div className="detail-card">
                  <h4>Address</h4>
                  <p>{user?.address || "Not Provided"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : type == "customer" ? (
        <div
          className="modal-backdrop"
          style={{
            background: "rgba(21, 2, 2, 0.5)", // Semi-transparent red background
            backdropFilter: "blur(10px)", // Apply the blur effect
            WebkitBackdropFilter: "blur(10px)", // For Safari support
          }}>
          <div className="modal-container" style={{ padding: "15px" }}>
            <header className="modal-header">
              <h2>Subcontractor & Customer Details</h2>
              <button className="icon-button" onClick={onClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </header>

            <div className="modal-content">
              <div className="user-avatar">
                <div className="avatar-circle">
                  {customer?.company_name
                    ?.split(" ")
                    .map((word) => word[0])
                    .join("") || "N/A"}
                </div>
                <h3>{customer?.company_name || "Not Provided"}</h3>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <span className="info-label">Contact person name</span>
                  <span className="info-value">
                    {customer?.contact_person_name || "Not Provided"}
                  </span>
                </div>

                <div className="info-card">
                  <span className="info-label">Contact person email</span>
                  <span className="info-value">
                    {customer?.contact_person_email || "Not Provided"}
                  </span>
                </div>

                <div className="info-card">
                  <span className="info-label">Contact person mobile No</span>
                  <span className="info-value">
                    {customer?.mobile_number || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">Type</span>
                  <span className="info-value">
                    {customer?.type == 1
                      ? "Subcontractor"
                      : customer?.type == 2
                      ? "Customer"
                      : "Not Provided" || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">GST No</span>
                  <span className="info-value">
                    {customer?.gst_no || "Not Provided"}
                  </span>
                </div>
                <div className="info-card">
                  <span className="info-label">Pan No</span>
                  <span className="info-value">
                    {customer?.pan_no || "Not Provided"}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <div className="detail-card">
                  <h4>Address</h4>
                  <p>{customer?.address || "Not Provided"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default UserDetailsModal;
